import React from "react";
import { cn } from "@/utils/helpers";
import styles from "../Svg.module.css";
import Svg, { SvgProps } from "../Svg";

export interface SvgIconProps extends SvgProps {}

export default function SvgIcon({
	width = 100,
	height = 100,
	className,
	children,
	...props
} : SvgIconProps) {
	return (
		<Svg
			width={width}
			height={height}
			className={cn(
				styles.SvgIcon,
				className
			)}
			{...props}
		>
			{children}
		</Svg>
	)
}
